import { envConfig } from "../../services/api";
import { loadStripe } from "@stripe/stripe-js";
import { setNumberPrecision } from "../../utils/common";
import { globalConfig } from "../../constants";
import * as PR from "../../prime-modules/index";
import { Link } from "react-router-dom";

export const stripePromise = loadStripe(envConfig.REACT_APP_STRIPE_PUBLIC_KEY,  {
    betas: ['custom_checkout_beta_4'],
  });

export const priceFormating = ({ price, bundlePrice, discountedPrice, promoCodePrice }) => ({
    amount: parseInt((discountedPrice ?? price) * 100),
    total: setNumberPrecision(bundlePrice ?? price),
    discount: setNumberPrecision(promoCodePrice ?? 0),
    grandTotal: setNumberPrecision(discountedPrice ?? price)
})

export const options = {
    mode: 'payment',
    amount: 0,
    currency: globalConfig.defaultCurrency
};



export const randomIdGenerator = (randomIdLength = 30) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let id = '';
  
    for (let i = 0; i < randomIdLength; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
  
    return id.match(/.{1,6}/g).join('-');
}

export const postData = {
    "paymentGateway": "none",
    "iccid": "",
    "isEsimCompatible": false,
    "deviceInfo": {
        "device": "website"
    },
    "randomId": randomIdGenerator()
}


export const CheckCompatible = ({ setChecked, checked, id, labels }) => (
    <div className="flex align-items-top gap-3 mb-5">
        <PR.Checkbox onChange={() => setChecked(p => ({ ...p, [id]: !checked[id] }))} checked={checked[id]}></PR.Checkbox>
        <label htmlFor="ingredient1">{labels?.LBLN0265} <Link target="_blank" to="/compatible-devices">{labels?.LBLN0007}</Link></label>
    </div>
)


export const addressElementOptions =  {
    appearance : {
        theme: 'stripe',
        'rules': {
            '.Input': {
                'backgroundColor': 'rgba(22, 0, 51, 0.1)',
                'border': '1px solid rgba(226, 227, 238, 0.13)',
                'borderRadius': '9px',
                'padding': '20px 25px',
                'fontSize': '18px',
                'color': 'white'
    
            },
            '.Input:focus': {
                'boxShadow': '0 0 0 0.2rem #c7d2fe'
            },
            '.Label': {
                'fontSize': '18px',
                'color': 'white',
                'marginTop': '15px',
                'marginBottom': '10px',
            },
            '.Error': {
                'color': "red"
            },
        },
    },
}

export const addressOptions = {
    mode: 'billing',
    autocomplete: {
        mode: "google_maps_api",
        apiKey: envConfig.REACT_APP_GOOGLE_MAP_API_KEY
    },
    fields: {
        'phone': 'always',
    },
    validation: {
        phone: {
            required: 'always'
        }
    },
}

export const elementsOptions = {
  appearance: {
    variables: {
      colorPrimary: "#ffffff",
      colorBackground: "#0E0020",
      colorText: "#ffffff",
      colorDanger: "#ff0000",
      fontFamily: "Ideal Sans, system-ui, sans-serif",
      spacingUnit: "5px",
      borderRadius: "10px",
    },
    rules: {
      ".Input:focus": {
        borderColor: "#0E0020",
        boxShadow:
          "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02), 0 0 0 2px var(--colorPrimary)",
      },
    },
  },
};
  
export const v2PaymentRequestData = {
    deviceInfo: { device: globalConfig.deviceInfo },
    isEsimCompatible: globalConfig.isEsimCompatible,
    paymentMethodId: randomIdGenerator(),
}

export const defaultPaymentMethodsList = [
  {
    CARD: "1",
  },
  {
    APPLEPAY: "2",
  },
  {
    PAYPAL: "3",
  },
  {
    GOOGLEPAY: "4",
  },
];